// Copyright (c) Konnecta Systems. All rights reserved.
// Licensed under the Custom License. See LICENSE file in the project root for full license information.
// This was autogenerated by zAppDev.
export enum IndirectCostsBaseEnum {
ELIGIBLE_DIRECT_COSTS_EXCL_SUBCONTRACTING,
ALL_ELIGIBLE_DIRECT_COSTS,
ELIGIBLE_DIRECT_COSTS_EXCL_SUBCONTRACTING_AND_3RD_PARTY,
}
